import {
    GET_ADMIN_AGREEMENTS,
    SET_ADMIN_AGREEMENTS,
    GET_ADMIN_AGREEMENT,
    SET_ADMIN_AGREEMENT,
    SAVE_ADMIN_AGREEMENT,
    GET_ADMIN_AGREEMENT_VERSION,
    SET_ADMIN_AGREEMENT_VERSION,
    SET_ADMIN_AGREEMENT_VERSIONS,
    SELECT_ADMIN_AGREEMENTS_LANGUAGE
} from './actions';

import AgreementService from '@services/admin_agreement.service';

const defaultState = () => {
    return {
        agreements: [],
        agreement: null,
        agreementVersions: [],
        agreementVersion: null,
        agreementsSelectedLanguage: {id: 'en', text: 'English'}
    };
};

export const agreementState = defaultState();

export const agreementMutations = {
    [SET_ADMIN_AGREEMENTS](state, data) {
        state.agreements = data;
    },
    [SET_ADMIN_AGREEMENT](state, data) {
        state.agreement = data;
    },
    [SET_ADMIN_AGREEMENT_VERSIONS](state, data) {
        state.agreementVersions = data;
    },
    [SET_ADMIN_AGREEMENT_VERSION](state, data) {
        state.agreementVersion = data;
    },
    [SELECT_ADMIN_AGREEMENTS_LANGUAGE](state, language) {
        state.agreementsSelectedLanguage = language;
    }
};

export const agreementActions = {
    [GET_ADMIN_AGREEMENTS]({commit}, language) {
        return AgreementService.getAgreements(language).then(res => {
            commit(SET_ADMIN_AGREEMENTS, res);
        });
    },
    [GET_ADMIN_AGREEMENT]({commit}, {id, language}) {
        commit(SET_ADMIN_AGREEMENT, null);
        commit(SET_ADMIN_AGREEMENT_VERSIONS, []);
        return AgreementService.getAgreement(id, language).then(res => {
            commit(SET_ADMIN_AGREEMENT, res);
            commit(SET_ADMIN_AGREEMENT_VERSIONS, res.versions ?? []);
        });
    },
    [GET_ADMIN_AGREEMENT_VERSION]({commit}, {agreementId, language, version}) {
        commit(SET_ADMIN_AGREEMENT_VERSION, null);
        return AgreementService.getAgreement(agreementId, language, version).then(res => {
            commit(SET_ADMIN_AGREEMENT_VERSION, res);
        });
    },
    [SAVE_ADMIN_AGREEMENT]({commit}, {id, data}) {
        return AgreementService.saveAgreement(id, data).then(res => {
            commit(SET_ADMIN_AGREEMENT, res);
            return res;
        });
    }
};

export const agreementGetters = {
    adminAgreements: state => state.agreements,
    adminAgreement: state => state.agreement,
    adminAgreementVersions: state => state.agreementVersions,
    adminAgreementVersion: state => state.agreementVersion,
    adminAgreementsSelectedLanguage: state => state.agreementsSelectedLanguage
};
